<template>
  <div class="bg-black min-h-screen">
  <div class="py-4 px-4">
    <div class="flex mt-6 justify-center">
      <h1 class="headline">
        <span>Moonsama v2.0 Preview</span>
        Moonsama v2.0 Preview
        <span>Moonsama v2.0 Preview</span>
      </h1>
    </div>

    <div class="flex my-6 items-center justify-center">
      <div class="flex flex-col w-96 max-w-max items-center">
        <div class="inline-block w-96 h-96 relative">
          <v-lazy-image :src="`https://msamabattle.duckdns.org/msamav2/background${background}.jpg`" class="absolute top-0 left-0 inline-block w-96 h-96" :class="{'hidden': !showBackground}" />
          <v-lazy-image :src="getTokenImage(selectedTokenId)" class="absolute top-0 left-0 inline-block w-96 h-96" />
          <v-lazy-image :src="`https://msamabattle.duckdns.org/msamav2/foreground${foreground}.png`" class="absolute top-0 left-0 inline-block w-96 h-96" :class="{'hidden': !showForeground}" />
        </div>
        <span v-if="selectedTokenId" class="my-4">MSAMA #{{ selectedTokenId }}</span>
      </div>
    </div>
    <div class="flex flex-col items-center justify-center">
      <a :href="downloadLink" target="_blank" class="button mb-4">Download</a>
      <div><label for="showBackground"><input type="checkbox" v-model="showBackground" id="showBackground"> Show Background</label> <select v-model="background" class="bg-black text-white border border-gray-700 hover:border-white p-2 bg-black text-white outline-none focus:border-red-700"><option value="">Background 1</option><option value="2">Background 2</option></select></div>
      <div class="mt-2"><label for="showForeground"><input type="checkbox" v-model="showForeground" id="showForeground"> Show Foreground</label> <select v-model="foreground" class="bg-black text-white border border-gray-700 hover:border-white p-2 bg-black text-white outline-none focus:border-red-700"><option value="">Foreground 1</option><option value="2">Foreground 2</option></select></div>
    </div>
    <div class="flex items-center my-4">
      <span class="mr-2">Filter:</span>
      <input type="text" v-model="filter" class="border border-gray-700 hover:border-white p-2 bg-black text-white outline-none focus:border-red-700" placeholder="Enter MSAMA ID" />
      <button @click.prevent="resetFilter" class="button ml-2">Clear</button>
    </div>
    <div class="flex flex-wrap items-center justify-items-start">
      <div class="my-4 p-2 w-4/12 md:w-2/12  xl:w-1/12 cursor-pointer border-2 border-transparent" @click.prevent="selectTokenId(tokenId)" :class="{'hidden': !filterToken(tokenId), 'border-th-secondary': tokenId == selectedTokenId}" v-for="tokenId in 1000" :key="tokenId">
        <v-lazy-image :src="getTokenImage(tokenId)" class="block px-4 w-full object-contain h-auto" />
        <div class="mt-2 text-center">MSAMA #{{ tokenId }}</div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import VLazyImage from "v-lazy-image/v2";

export default {
  name: 'SelectionScreen',
  components: {
    VLazyImage
  },
  data() {
    return {
      filter: "",
      selectedTokenId: 1,
      background: "",
      foreground: "",
      showBackground: true,
      showForeground: true,
    }
  },
  computed: {
    downloadLink: function() {
      let url = `https://msamabattle.duckdns.org/msamav2/download.php?tokenId=${this.selectedTokenId}`
      if (this.showBackground) url += `&background=${this.background}`
      if (this.showForeground) url += `&foreground=${this.foreground}`

      return url
    }
  },
  methods: {
    getTokenImage(tokenId) {
      return "https://msamabattle.duckdns.org/msamav2/" + tokenId + ".png"
    },

    filterToken(tokenId) {
      if (this.filter === null || this.filter === "") {
        return true
      }

      if (tokenId == parseInt(this.filter) || String(tokenId).startsWith(this.filter)) {
        return true
      }

      return false
    },

    selectTokenId(tokenId) {
      this.selectedTokenId = tokenId
      window.scrollTo(0, 0);
    },

    resetFilter() {
      this.filter = null
    }
  }
}
</script>